import { extractSelectedValues } from '../../../../../components/organisms/Filters/utils';
import { Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { formatQueryDate } from '../../../../../utils/timeUtils';
import { maskEntry } from '../../../../../utils/utils';
import { formatterDots } from '../../../features/parcels/api/getDots';
import { parcelKeys } from '../../parcels/controllers/variables';
import { productKeys } from '../controllers/variables';

export const useGetProducts = ({ searchParams, ignore }) => {
  const params = formatParams(searchParams);

  const [
    {
      data: { products = [], product_count: productCount = 0 } = {},
      isLoading = true,
      isError,
      error,
    },
    getProducts,
    refreshTable,
  ] = useFetchData('office_products', {
    params,
    ignore,
    large: true,
  });

  return {
    data: { products: maskData(products, mask), productCount },
    isLoading,
    isError,
    error,
    getProducts,
    refreshTable,
  };
};

export const formatParams = params => {
  const {
    TIME_FRAME,
    SEARCH: search,
    PRODUCT_STATUS,
    CUSTOMER,
    PRODUCT_CATEGORY,
    PAGE,
    ITEMS_PER_PAGE,
    LOCATION,
    ACTOR_DATA,
  } = params;

  const from_date = formatQueryDate(TIME_FRAME?.value?.fromDate);
  const to_date = formatQueryDate(TIME_FRAME?.value?.toDate);

  const status = extractSelectedValues(PRODUCT_STATUS);
  const brand_id = extractSelectedValues(CUSTOMER);
  const category_id = extractSelectedValues(PRODUCT_CATEGORY);
  const sorter_id = extractSelectedValues(LOCATION);
  const actor_data = extractSelectedValues(ACTOR_DATA);

  const formattedParams = {
    search,
    status,
    brand_id,
    sorter_id,
    from_date,
    to_date,
    category_id,
    offset: (PAGE - 1) * ITEMS_PER_PAGE,
    limit: ITEMS_PER_PAGE,
    actor_data,
  };

  if (formattedParams?.status?.includes('Stopped'))
    formattedParams?.status?.push('Customs');
  if (
    formattedParams?.status?.includes('Customs') &&
    !formattedParams?.status?.includes('Stopped')
  )
    formattedParams.status = formattedParams?.status?.filter(
      x => x !== 'Customs'
    );

  return formattedParams;
};

const maskData = (data, mask) => {
  maskEntry(data, mask);
  return data.map(entry => ({
    ...entry,
    ...formatterDots(entry),
    id: entry[productKeys.productId],
  }));
};

const mask = {
  [Field_Keys.PRODUCT.BRAND_ID]: productKeys.brand,
  [Field_Keys.PRODUCT.ID]: productKeys.productId,
  [Field_Keys.PRODUCT.ALIAS]: productKeys.productAlias,
  [Field_Keys.PRODUCT.STATUS]: productKeys.productStatus,
  [Field_Keys.PRODUCT.STATUS_NEXT_OPTIONS]: productKeys.productActions,
  [Field_Keys.PARCEL.SIDELOAD_DATE]: productKeys.productSideloadDate,
  [Field_Keys.PRODUCT.CREATED_AT]: productKeys.inspectionDate,
  [Field_Keys.CATEGORY.SUBCATEGORY_NAME]: productKeys.subCategory,
  [Field_Keys.PARCEL.DETECTION_CONFIDENCE]: productKeys.confidence,
  [Field_Keys.PRODUCT.IS_PRODUCT_OWNER]: productKeys.isProductOwner,
  [Field_Keys.PRODUCT.STATUS_UPDATED_AT]: productKeys.lastActivity,
  [Field_Keys.PARCEL.ID]: productKeys.parcelId,
  [Field_Keys.PARCEL.ALIAS]: productKeys.parcel.alias,
  [Field_Keys.REFERENCE.ID]: productKeys.referenceId,
  [Field_Keys.REFERENCE.BRAND_NAME]: productKeys.referenceBrandName,
  [Field_Keys.REFERENCE.NAME]: productKeys.referenceName,
  [Field_Keys.REFERENCE.COMPANY]: productKeys.referenceCompany,
  [Field_Keys.SORTER.ID]: productKeys.sorterId,
  [Field_Keys.SORTER.NAME]: productKeys.sorterName,
  [Field_Keys.SORTER.CITY]: productKeys.sorterCity,
  [Field_Keys.SORTER.COUNTRY]: productKeys.sorterCountry,
  [Field_Keys.CATEGORY.NAME]: productKeys.category,
  [Field_Keys.PRODUCT.ITEM_QUANTITY]: productKeys.productQuantity,
  [Field_Keys.PRODUCT.IS_BRAND_CONTRACTED]: productKeys.isContracted,
  [Field_Keys.PRODUCT.BRAND_NAME]: productKeys.brandObj.name,
  [Field_Keys.PARCEL.IS_HOLD_CONFIRMED]: parcelKeys.isHoldConfirmed,
  [Field_Keys.PARCEL.IS_REPORT_CONFIRMED]: parcelKeys.isReportConfirmed,
  [Field_Keys.PARCEL.IS_SEIZE_CONFIRMED]: parcelKeys.isSeizeConfirmed,
  [Field_Keys.PARCEL.IS_STOP_CONFIRMED]: parcelKeys.isStopConfirmed,

};
